import { render, staticRenderFns } from "./GroupSchoolFeeReport.vue?vue&type=template&id=712b98e0&scoped=true"
import script from "./GroupSchoolFeeReport.vue?vue&type=script&lang=js"
export * from "./GroupSchoolFeeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712b98e0",
  null
  
)

export default component.exports